import { BrowserRouter, Routes, Route } from "react-router-dom"
import Projects from "./pages/Projects"
import Company from "./pages/Company"
import Ecosystem from "./pages/Ecosystem"
import Contact from "./pages/Contact"
import ScrollToTop from "./ScrollToTop"

function AppRoutes() {
    return(
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={ <Company /> }></Route>
                <Route path="/project" element={ <Projects /> }></Route>
                <Route path="/ecosystem" element={ <Ecosystem /> }></Route>
                <Route path="/contact" element={ <Contact /> }></Route>             
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes
